import { useEffect, useState } from "react";
import { PLAYER } from "@/lib/content";

export default function Header({ stats }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const pct = Math.min(100, stats?.percentage || 0);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-[#27272A]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <div className="h-9 w-9 grid place-items-center bg-[#FF007F] text-white font-display text-xl">
            {PLAYER.jersey}
          </div>
          <div className="leading-tight">
            <div className="font-display uppercase text-base tracking-wider">Camden Clichee</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA]">
              Believe &amp; Give
            </div>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
          <a href="#story" className="link-reveal hover:text-white">Story</a>
          <a href="#gallery" className="link-reveal hover:text-white">Gallery</a>
          <a href="#believe" className="link-reveal hover:text-white">Believe</a>
          <a href="#donors" className="link-reveal hover:text-white">Donors</a>
        </div>

        <a
          href="#donate"
          data-testid="header-donate-cta"
          className="relative inline-flex items-center bg-[#FF007F] text-white px-5 py-2.5 font-bold text-xs uppercase tracking-[0.2em] hover:-translate-y-0.5 transition-transform"
        >
          Donate
          <span className="ml-3 text-[#FFC2DB] tabular">{pct.toFixed(0)}%</span>
        </a>
      </div>
    </header>
  );
}
